const $ = jQuery;
export const isOnViewport  =  (element, deb) =>{
	var elementOffsetTop = element.offset().top;
	var elementHeight = element.height();
	var elementWidth = element.width();

	var screenScrollTop = $(window).scrollTop();
	var screenHeight = $(window).height();
	var screenWidth = $(window).width();
	var rect={};
	rect.y1 = Math.max(screenScrollTop, elementOffsetTop);
	rect.y2 = Math.min(elementOffsetTop+elementHeight, screenScrollTop+screenHeight);
	if (deb) 
	if (elementOffsetTop>screenHeight + screenScrollTop) {
		return false;
	}
	if (rect.y2 < rect.y1) {
		if (deb) console.log('rect.y2 < rect.y1', rect.y2, rect.y1);
		return false;
	}
	var visiblePourcentage =  (rect.y2-rect.y1)/(elementHeight);
	if (deb) {
		console.log(visiblePourcentage+'% is visible');
		console.log({elementOffsetTop, elementHeight, screenScrollTop});
	}
	return (visiblePourcentage > .25);
}

window.isOnViewport = isOnViewport;

const handleOnViewport = function(){
	$('[data-watch-viewport]').each(function(){
		let isVisible = isOnViewport($(this));
		if (isVisible){
			$(this).addClass('is-in-viewport');
		}
		else {
			$(this).removeClass('is-in-viewport');
		}
	});
}

$(document).ready(function(){
	$(window).scroll(handleOnViewport);
});

